module.exports = __webpack_public_path__ + "static/media/IMG_0346.234609a3.JPG";